<router-outlet [ngClass]="langClass"
  appConsoleWarning
  (activate)="moveScrollToTop()" />
